import React from 'react';

const Logo = ({ size = 100, square = false }) => {
    const config = window.APP_CONFIG;

    if (!config) return null;

    const logoUrl = square ? config.logo_square : config.logo;

    return (
        <img
            src={logoUrl}
            alt="App Logo"
            width={size}
            height={size}
            style={{ objectFit: 'contain' }}
        />
    );
};

export default Logo;

/*

import Logo from './Components/Shared/Logo';

// لوگوی مستطیلی بزرگ
<Logo size={200} />

// لوگوی مربع کوچک
<Logo size={50} square />
*/
